<template>
    <div>
        <nav-bar />
        <div class="main">
            <banner />
            <mainSection />
            <site-footer />
        </div>
    </div>
</template>

<script>
import NavBar from "../views/commons/NavBar";
import Banner from "../views/servicesPage/Banner";
import mainSection from "../views/servicesPage/mainSection";
import SiteFooter from "../views/index-five/SiteFooter";

export default {
    name: "DownloadPage",
    components: {
        NavBar,
        Banner,
        mainSection,
        SiteFooter,
    },
};
</script>

